// umlaut-check: skip — "zuruecksetzen" ist der technische Name aus
// useGemerkteFilter.jsx, bleibt ASCII.
import React from 'react';
import InertiaTable from 'laravel-inertia-react-table';
import {router, usePage} from '@inertiajs/react';
import axios from 'axios';
import {PiArrowClockwise} from 'react-icons/pi';
import {FlexToast, useEnhancedTranslation, useExternalControls, usePolling} from 'laravel-inertia-backend';
import TimestampTableCell from '../../Components/TimestampTableCell.jsx';
import StatusBadgeTableCell from '../../Components/StatusBadgeTableCell.jsx';
import ProgressTableCell from '../../Components/ProgressTableCell.jsx';
import {AlleFilterZuruecksetzenLink, useGemerkteServerFilter} from "../../Components/Filter/useGemerkteFilter.jsx";

export default function TransmissionJobs() {
    const {transmission_jobs, col_definitions, auth} = usePage().props;
    const {t} = useEnhancedTranslation();
    const {addToast} = useExternalControls();
    usePolling('weclapp_transmission_jobs');
    const {weichtAb, zuruecksetzen} = useGemerkteServerFilter("weclapp.transmission-jobs", {benutzerId: auth?.id});

    const retry = async (row) => {
        if (row.status !== 'failed') {
            addToast(<FlexToast variant={'warning'} title={'Weclapp'} autohide={true}
                                message={'Nur fehlgeschlagene Übertragungen können fortgesetzt werden.'}/>);
            return;
        }
        try {
            await axios.post(`/weclapp/transmission/${row.id}/retry`);
            addToast(<FlexToast title={'Weclapp'} autohide={true} message={'Übertragung wird fortgesetzt.'}/>);
            router.reload({only: ['transmission_jobs']});
        } catch (e) {
            const msg = e.response?.data?.message || e.message;
            addToast(<FlexToast variant={'danger'} title={'Weclapp'} autohide={false}
                                message={`Fortsetzen fehlgeschlagen: ${msg}`}/>);
        }
    };

    return (
        <InertiaTable
            key={'transmission-jobs-table'}
            data={transmission_jobs}
            title={'Weclapp-Übertragungen'}
            actionsDisplay={'column'}
            actions={[
                {icon: <PiArrowClockwise/>, alt: t('resume transmission'), callback: (row) => retry(row)},
            ]}
            colDefinitions={[...col_definitions]}
            customCellRendererMap={{
                'status': StatusBadgeTableCell,
                'progress_percent': ProgressTableCell,
                'created_at': TimestampTableCell,
                'updated_at': TimestampTableCell,
            }}
            customToolbarButtons={<AlleFilterZuruecksetzenLink sichtbar={weichtAb} onClick={zuruecksetzen} />}
        />
    );
}
